var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rows-pending"},[_c('CSpinner',{staticClass:"rows-pending__spinner",attrs:{"variant":"secondary","label":"Results pending"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }